export default __webpack_public_path__ + "static/media/mama_papa.1760961e.png";